module.exports = __webpack_public_path__ + "img/6.2fbc8f5e.png";